export const createTriggerCacheKey = (
  machineLearningModel: string,
  siteId: string
) => `trigger-task-data-science-${machineLearningModel}-${siteId}`;

export const createUpdateCacheKey = (
  machineLearningModel: string,
  siteId: string
) => `update-data-science-${machineLearningModel}-${siteId}`;
